import { createFileRoute } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { Heading } from 'components/Heading';
import { LinkTable } from 'components/Table';
import { BadgeAlert, Plus } from 'lucide-react';
import { emitMessage } from 'engine/api';

export const Route = createFileRoute('/dashboard/users/')({
	component: RouteComponent,
	loader: async () => {
		const users = await emitMessage({ kind: 'get-users' });
		return users;
	},
});

function RouteComponent() {
	const users = Route.useLoaderData();

	if ('error' in users) {
		return <div>Error: {users.error}</div>;
	}

	// const modes: Record<string, string> = {
	// 	Reseller: 'yellow',
	// 	Admin: 'blue',
	// };

	return (
		<>
			<div className="flex flex-col gap-3">
				<div className="border-yellow flex items-center gap-3">
					<Heading>Users</Heading>
					<Button to="/dashboard/users/new">
						New User <Plus className="size-4" />
					</Button>
				</div>

				<div>
					<LinkTable
						headers={[
							'Name',
							'Email',
							'Create date',
							// '2FA',
							// 'Role',
						]}
						rows={users?.map((u) => {
							return {
								href: '/dashboard/users/' + u.id,
								data: [
									`${u.firstName} ${u.lastName}`,
									<span className="flex items-center gap-2 text-gray-500">
										{u.email}
										{!u.emailVerified && (
											<div className="group relative flex items-center">
												<BadgeAlert className="size-4 text-red-600" />
												{/* <span className="before:bg-inherit pointer-events-none absolute -right-4 translate-x-full whitespace-nowrap rounded-md border border-gray-200 bg-white p-2 leading-none text-gray-800 opacity-0 drop-shadow-sm before:absolute before:left-0 before:top-1/2 before:block before:size-2 before:-translate-x-1/2 before:-translate-y-1/2 before:rotate-45 before:rounded-sm before:border before:border-gray-200 before:bg-white before:clip-half group-hover:opacity-100 group-data-[expanded]/nav:hidden dark:border-gray-700 dark:bg-gray-950 dark:text-gray-100 dark:before:border-gray-700 dark:before:bg-gray-950"> */}
												<span className="before:bg-inherit pointer-events-none absolute -right-1 translate-x-full whitespace-nowrap rounded-md border border-gray-200 bg-white p-2 leading-none text-gray-800 opacity-0 drop-shadow-sm before:absolute before:left-0 before:top-1/2 before:block before:size-2 before:-translate-x-1/2 before:-translate-y-1/2 before:rotate-45 before:rounded-sm before:border before:border-gray-200 before:bg-white before:clip-half group-hover:opacity-100">
													Email not verified
												</span>
											</div>
										)}
									</span>,
									new Date(u._created_at).toLocaleString('nl-NL', {
										hour: '2-digit',
										minute: '2-digit',
										day: '2-digit',
										month: '2-digit',
										year: 'numeric',
									}),
									// <ShieldCheck className={u.mfa ? 'text-success-800' : 'text-danger-700'} />,
									// <Badge status={'custom'} custom={modes[u.role]}>
									// 	{u.role}
									// </Badge>,
								],
							};
						})}
					/>
				</div>
			</div>
		</>
	);
}
